/**
 * 🎮 モバイルフッター表示制御のフック
 */
import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export const useMobileFooter = () => {
  const [showFooter, setShowFooter] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const location = useLocation();

  // 認証状態の監視
  useEffect(() => {
    const checkAuth = () => {
      const token = localStorage.getItem('token');
      const isAuth = !!token;
      setIsAuthenticated(isAuth);
      // デバッグログ削除（白画面問題対策）
    };

    checkAuth();

    // localStorageの変更を監視
    window.addEventListener('storage', checkAuth);

    // カスタムイベントでの認証状態変更も監視
    const handleAuthChange = () => {
      // デバッグログ削除
      checkAuth();
    };
    window.addEventListener('authChange', handleAuthChange);

    return () => {
      window.removeEventListener('storage', checkAuth);
      window.removeEventListener('authChange', handleAuthChange);
    };
  }, []);

  // フッターを表示しないページ
  const hiddenPaths = [
    '/login',
    '/register',
    '/signin',
    '/admin-login',
    '/auth/verify-magic-link',
    '/introduction',
    '/kyc',
    '/notifications',
    '/feed/threads',
    '/group-chat/',
    '/store-chat/',
    '/dao-chat/',
  ];

  // 画面サイズの監視
  useEffect(() => {
    const checkMobile = () => {
      const mobile = window.innerWidth <= 768; // md breakpoint
      setIsMobile(mobile);
    };

    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  // ページごとの表示制御
  useEffect(() => {
    // より確実な認証状態確認
    const token = localStorage.getItem('token');
    const user = localStorage.getItem('user');
    let isReallyAuthenticated = false;

    // トークンと権限レベルの詳細チェック
    if (token && user) {
      try {
        // JWTトークンをデコードして権限レベルを取得
        const tokenParts = token.split('.');
        if (tokenParts.length === 3) {
          // Base64のパディング調整
          let base64 = tokenParts[1].replace(/-/g, '+').replace(/_/g, '/');
          while (base64.length % 4) {
            base64 += '=';
          }
          const payload = JSON.parse(atob(base64));
          const permissionLevel = payload.permission_level || 0;
          const isGuest = payload.isGuest || false;
          
          // ゲストユーザーでなく、かつ権限レベルが2以上の場合
          if (!isGuest && permissionLevel >= 2) {
            isReallyAuthenticated = true;
          }
        }
      } catch (e) {
        // トークンデコードエラーの場合はfalse
      }
    }

    const isHiddenPath = hiddenPaths.some((path) =>
      location.pathname.startsWith(path)
    );
    const isRootPage = location.pathname === '/';

    // 表示条件 - レスポンシブ対応版
    // 1. 実際に認証済み（準会員以上）
    // 2. 隠しページでない
    // 3. ルートページでない
    // 注：モバイル・PC両対応（レスポンシブで表示形式が変わる）
    const shouldShow = isReallyAuthenticated && !isHiddenPath && !isRootPage;

    setShowFooter(shouldShow);
  }, [isMobile, location.pathname, isAuthenticated]);

  return {
    showFooter,
    isMobile,
  };
};
